/** AL/RL 0–5 band colors — shared by LevelTrendChart (SVG hex) and synopsis tags (Tailwind). */

const LEVEL_BAND_CLASSES: Record<string, string> = {
  "0": "bg-slate-100 text-slate-500",
  "1": "bg-red-50 text-red-600",
  "2": "bg-orange-50 text-orange-600",
  "3": "bg-amber-50 text-amber-700",
  "4": "bg-emerald-50 text-emerald-700",
  "5": "bg-emerald-100 text-emerald-700",
};

/** Hex equivalents of LEVEL_BAND_CLASSES for use inside SVG (recharts ticks can't consume Tailwind classes). */
export const LEVEL_BAND_HEX: Record<string, { bg: string; text: string }> = {
  unknown: { bg: "#F1F5F9", text: "#64748B" },
  "0": { bg: "#F1F5F9", text: "#64748B" },
  "1": { bg: "#FEF2F2", text: "#DC2626" },
  "2": { bg: "#FFF7ED", text: "#EA580C" },
  "3": { bg: "#FFFBEB", text: "#B45309" },
  "4": { bg: "#ECFDF5", text: "#047857" },
  "5": { bg: "#D1FAE5", text: "#047857" },
};

export const levelBandClasses = (level: number | null | undefined): string => {
  if (level == null || !Number.isFinite(level))
    return "bg-gray-100 text-gray-400";
  const clamped = Math.max(0, Math.min(5, Math.round(level)));
  return LEVEL_BAND_CLASSES[String(clamped)];
};

/** Hex equivalent of levelBandClasses, for badges rendered inside raw SVG. */
export const levelBandHex = (
  level: number | null | undefined
): { bg: string; text: string } => {
  if (level == null || !Number.isFinite(level)) return LEVEL_BAND_HEX.unknown;
  const clamped = Math.max(0, Math.min(5, Math.round(level)));
  return LEVEL_BAND_HEX[String(clamped)];
};

export const formatLevelBadge = (
  prefix: "AL" | "RL",
  level: number | null | undefined
): string => {
  if (level == null || !Number.isFinite(level)) return `${prefix} ?`;
  const clamped = Math.max(0, Math.min(5, Math.round(level)));
  return `${prefix} ${clamped}`;
};
